<template>
  <div class="h-100">
    <div class="vue-datatables">
      <div class="row mb-3 flex-wrap" >
        <div class="col-auto mb-2" v-for="option in types" v-if="option.count">
          <status-filter :is-selected="selectedCustomFilter == option.key" :status="option"
                       @selected="doCustomFilter('leadType' ,option.key)"
          />
        </div>
      </div>
      <v-server-table :columns="columns" :options="options">
        <!-- SLOTS FIELDS EDIT -->
        <template v-for="item in columns" :slot="'h__' + item">
          <span>{{ $t('tables.headers.' + item) }}</span>
        </template>
        <div slot="beforeLimit">
          <div class="d-flex justify-content-between ml-2">


            <div v-if="!tconfig.hideDateFilter" class="input-group">
              <input class="form-control"
                     type="text"
                     :placeholder="$t('message.dateFilter')"
                     name="daterange"
                     @focus="openDateRange">
              <div class="input-group-append">
                <button class="btn btn-danger" type="button" v-if="dateFilter"
                        @click="clearDateFilter()">
                  {{ $t('message.clean') }}
                </button>
                <div v-else
                     class="input-group-text px-1 d-flex justify-content-center align-items-center">
                  <span class="icon-calendar"></span>

                </div>
              </div>
            </div>
          </div>
        </div>
        <template v-for="(item) in tconfig.schema" v-slot:[item.name]="props">
          <div class="td-wrapper" :ref="props.row.id+'_'+item.name">
            <template v-if="item.options">
              <div v-html="translateById(props.row[item.name], item.options)"></div>
            </template>

            <span v-else>
              <span
                :style="{'color' : $route.name === 'statuses' && item.name === 'color' ? props.row['color'] + '!important' : ''}">{{ props.row[item.name] }}</span>
            </span>
            <form-control v-if="item.editable"
                          :type="item.type"
                          :name="item.name"
                          :id="`${item.name}_${props.row.id}`"
                          classes="mb-0"
                          class="d-none mb-0"
                          v-validate="item.validation"
                          v-model="props.row[item.name]"
                          :options="getFieldOptions(item.options)"
                          :error="errors.first(item.name)"
                          :val="props.row[item.name]"
            />
          </div>
        </template>
      </v-server-table>
    </div>
  </div>
</template>

<script>
import config from "@/table-config";
import axios from "@/axios";
import DataTable from "@/mixins/DataTable";
import Auth from "@/mixins/Auth";
import Excel from "@/mixins/Excel";
import StatusFilter from "@/components/StatusFilter";
export default {
  name: "OrdersView",
  components: {StatusFilter},
  mixins: [DataTable,Auth,Excel],
  data(){
    return {
      types:[],
      config: {},
      tconfig: {},
      selectedCustomFilter:null,
      options: {
        filterable: true,
        dateColumns: [],
        columnsDropdown: this.$store.getters.isAdmin || this.$store.getters.isManagement || '',
        async requestFunction(params) {
          return await axios.post(`/v2/orders`, params);
        },
        responseAdapter(response) {
          return {data: response.data.data, count: response.data.total}
        },
        "perPageValues": [
          10,
          25,
          50,
          100,
          100000000
        ],
        "initFilters": null,
        "filterBySearchBox": "",
        "orderBy": {
          "ascending": "",
          "column": ""
        },
        "columnsDisplay": {},
        "perPage": 50,
        "texts": {
          "count": "מציג {from} עד {to} מתוך {count} רשומות|{count} רשומות|רשומה 1",
          "filter": "",
          "filterPlaceholder": "ביטוי לחיפוש",
          "limit": "רשומות",
          "limitPlaceholder": "רשומות",
          "page": "עמוד",
          "noResults": "לא נמצאו רשומות",
          "filterBy": "סנן לפי {column}",
          "loading": "טוען...",
          "defaultOption": "בחר {column}",
          "columns": "עמודות"
        },
        "sortable": [
          "id",
          "ins-type",
          "statusId",
          "created_at",
          "insurance-date-start",
          "first-name",
          "last-name",
          "identical-number",
          "license-number",
          "hovaCompany",
          "secondCompany",
          "billingDate",
          "orderSource",
          "paymentKind",
          "createdFrom",
          "mobile-phone-number",
          "additional-phone-number",
          "email",
          "protectiveStatus",
          "lackOfClaimsStatus",
          "userIp",
          "surfingSource"
        ],
        "columnsClasses": {
          "id": "id",
          "actions": "actions"
        },
        "pagination": {
          "chunk": 10,
          "dropdown": false,
          "nav": "scroll"
        },
        "customFilters": [
          {
            "name": "statusId"
          }
        ],
        "sortIcon": {
          "base": "fontawesome",
          "up": "fa fa-chevron-up",
          "down": "fa fa-chevron-down",
          "is": "fa fa-sort"
        }
      }
    }
  },
  computed:{
    tcfilters() {
      return this.tconfig.cfilters
    },
    columns() {
      return [
        "actions",
        "id",
        "ins-type",
        "statusId",
        "created_at",
        "insurance-date-start",
        "first-name",
        "last-name",
        "identical-number",
        "license-number",
        "hovaCompany",
        "secondCompany",
        "billingDate",
        "orderSource",
        "paymentKind",
        "createdFrom",
        "mobile-phone-number",
        "additional-phone-number",
        "email",
        "protectiveStatus",
        "lackOfClaimsStatus",
        "userIp",
        "surfingSource"
      ]
    }
  },
  async created() {
    let tconfig = config.orders
    if (tconfig) {
      this.config = tconfig
    } else {
      this.config = {}
    }
    try {

      let response = await axios.post("v2/orders/options");
      this.types = response.data.statuses
      this.statuses = response.data.statuses
      this.config.options = response.data;
    } catch (e) {

    }
  }
}
</script>

<style scoped>

</style>
